jQuery(document).ready(function($) { 
 $(".ActionToChild-js").click(function() {
      document.location = $(this).find('a').attr("href");
   });

 $('.EventList, .EventList_evt_cgi').on('click', '.EventList-Item', function (){
    
    window.open(
      $(this).find('a').attr('href'),
      $(this).find('a').attr('target')
    );

  });
  

  /// LOAD MORE POUR AJAX AGENDA ///

  // 1.0 /// Evt special lien externe //
    var ajaxUrl = my_ajax_object.ajax_url;
    var page = 1; // What page we are on.
    var ppp = 3; // Post per page
    var nb_max_page = 10;

    nb_max_page = parseInt($("#more_posts_cours_seminaire").attr('data-numbermaxpage'));
   
    $("#more_posts_cours_seminaire").on("click",function(e){ // When btn is pressed.
        $("#loader_seminaire_cours").addClass('is-active');
        $("#more_posts_cours_seminaire").attr("disabled",true); // Disable the button, temp.
        $.post(ajaxUrl, {
            action:"more_post_ajax",
            offset: (page * ppp),
            ppp: ppp
        }).success(function(posts){
            page++;
            $("#loader_seminaire_cours").removeClass('is-active');
            $(".EventList").append(posts); // CHANGE THIS!
            $("#more_posts_cours_seminaire").attr("disabled",false);

            if(page == nb_max_page) $("#more_posts_cours_seminaire").hide();
        });

        e.preventDefault();
   });


  /// 2.0 // Evt special interne avec permalink
    var page_evt_cgi = 1; // What page we are on.
    var ppp_evt_cgi = 3; // Post per page
    var nb_max_page_evt_cgi = 10;

    nb_max_page_evt_cgi = parseInt($("#more_posts_cours_evt_cgi").attr('data-numbermaxpage'));
    

    $("#more_posts_cours_evt_cgi").on("click",function(e){ // When btn is pressed.
        $("#loader_evt_cgi").addClass('is-active');
        $("#more_posts_cours_evt_cgi").attr("disabled",true); // Disable the button, temp.
        $.post(ajaxUrl, {
            action:"more_post_ajax_evt_cgi",
            offset: (page_evt_cgi * ppp_evt_cgi) + 1,
            ppp_evt_cgi: ppp_evt_cgi
        }).success(function(posts){
            page_evt_cgi++;
            $("#loader_evt_cgi").removeClass('is-active');
            $(".EventList_evt_cgi").append(posts); // CHANGE THIS!
            $("#more_posts_cours_evt_cgi").attr("disabled",false);

            if(page_evt_cgi == nb_max_page_evt_cgi) $("#more_posts_cours_evt_cgi").hide();


        });

        e.preventDefault();
   });




  /* GALEIRE MEMBRES DU COMITE */
    $('.Membres-Container-row').slick({
        //setting-name: setting-value
        dots: true,
        draggable:true,
        arrows:true,
        speed:1400,
        slidesToShow: 5,
        slidesToScroll: 5,
         responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          }
        ]

      });


	/* GALERIE PHOTO TOP ACCUEIL */
	$('.GalleryTopHome').slick({
        //setting-name: setting-value
        dots: false,
        infinite:true,
        arrows:false,
        draggable:false,
        autoplay: true,
  		autoplaySpeed: 3000,
  		speed:1400,
  		fade: true,
      });

	/* GALERIE EVT POUR AGENDA */
	$('.AgendaHome-Slide').slick({
        //setting-name: setting-value
        dots: true,
        draggable:true,
        arrows:true,
  		  speed:1400,
         responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
           {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:false,
            }
          }
        ]

      });
	

  /* Active jquery dropdown */

  // $('.to_nicedropdown-js').niceSelect();
   $('.to_nicedropdown-js').niceSelect();
   $('#sujet, #type_adhesion').niceSelect();

   $('.to_nicedropdown-js').on('change', function() {
    document.location=this.value;
  });

   /* ACTUS MASONRY */
   $('.gridpost').masonry({
    // options
    itemSelector: '.Post-Resume',
    columnWidth: '.gridpost-sizer',
    gutter: '.gridpost-gutter-sizer',
    percentPosition: true, 
  });



   /* TOGLLE SLIDE POUR PARTAGE ARTICLES */
   
   $('#ShareContentPost-Content').hide();

  $( ".ShareContentPost-Content-js" ).click(function() {
      $(".ShareContentPost-Content-js").toggleClass('active');
      $( "#ShareContentPost-Content" ).slideToggle( 400, function() {


      // Animation complete.
    });

      return false;
  });



  /* TOGGLE TAB */

  // http://www.entheosweb.com/tutorials/css/tabs.asp
    $(".Tabs-Content-js").hide();
    //$(".Tabs-Content-js:first").show();

  /* if in tab mode */
    $("ul.tabs li").click(function() {
    
      $(".Tabs-Content-js").hide();
      var activeTab = $(this).attr("rel"); 
      $("#"+activeTab).fadeIn();    
    
      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

    $(".Tabs-Title-js").removeClass("d_active");
    $(".Tabs-Title-js[rel^='"+activeTab+"']").addClass("d_active");
    
    });
  /* if in drawer mode */
  $(".Tabs-Title-js").click(function() {
      
      if($(this).next().css('display') == 'none'){
          $(".Tabs-Content-js").hide();
          var d_activeTab = $(this).attr("rel"); 
          $("#"+d_activeTab).fadeIn();
        
        $(".Tabs-Title-js").removeClass("d_active");
          $(this).addClass("d_active");
        
        //$("ul.tabs li").removeClass("active");
       // $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    }else{
      $(this).next().slideUp(400);
      $(".Tabs-Title-js, ul.tabs li").removeClass("d_active");
    }
    });


}); // fin ready menu